let momentToDate = function (dat) {
  "use strict";

  if (moment.isMoment(dat)) {
    dat = moment(dat).toDate();
  }

  return dat;
};

module.exports = momentToDate;


// WEBPACK FOOTER //
// ./app.v2/assets/js/momentToDate.js